import React from 'react';
import Paper from '@material-ui/core/Paper';
import { Header, Icon, Card, Input, Image } from 'semantic-ui-react';
import Avatar from '@material-ui/core/Avatar';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import $ from 'jquery';
import Title from './title';
import './login.css';
import Logoss from '../media/icon.png';

class Reset extends React.Component {

  state = {
    
  }

  resetPassword() {

  }

  handleText(name, e) {
    this.setState({
      [name]: e.target.value
    });
  }

  render() {
    return (
      <div>
      <Title />
      <center style={{marginTop: '10%', padding: '2%'}}>
        <Card id="login">
        <br/>
          <Avatar alt="Vaigai Claas" src={this.state.imagessss} style={{margin: 10, height: '20%', width: '20%'}}  />
          <Header as='h2' icon textAlign='center' style={{marginTop: 10, color: '#abb119'}}>
            <Header.Content>Admin Login</Header.Content>
          </Header>
          <Input id="password" focus type="password" placeholder='Password' onChange={this.handleText.bind(this, "password")} fluid />
          <br />
          <Input id="conformpassword" focus type="conformpassword" placeholder='Conform Password' onChange={this.handleText.bind(this, "conformpassword")} fluid />
          <br />
          <div style={{color: 'red', fontSize: 14, fontWeight: 'bold'}}>{this.state.error}</div>
          {
            this.state.loading == false &&
            <Button variant="contained" style={{padding: '3%', backgroundColor: '#abb119', fontWeight: 'bold', color: '#ffffff'}}
              onClick={this.resetPassword.bind(this)} id="buttonClicked">
              Reset
            </Button>
          }
          {
            this.state.loading &&
            <CircularProgress />
          }
          <br />
        </Card>
      </center>
      </div>
    );
  }
}

export default Reset;
